let config = {
    title: `The Gravedigger: Extraction`,
    copyright: '©2026 Mitory',
    email: 'mitorypt@gmail.com',
    policy: 'https://app.furyglow.com/privacy_policy',
    term: 'https://app.furyglow.com/terms',
    introduceTitle: 
        `Uncover the secrets of a sealed thousand-year tomb in this thrilling roguelike dungeon adventure! The ancient crypt’s protections have weakened—now it’s overrun with traps, undead guardians, and mutated creatures. Stranded deep underground, you must rely on wits, agility, and magical artifacts to survive and find your way out.`,
    introduceText: [
        {
            title: '• Atmospheric Tomb Exploration – Navigate eerie burial chambers filled with hidden puzzles, treasure vaults, and lurking dangers.',
            text: ''
        },
        {
            title: '• Roguelike Progression – Each run offers randomized relics and power-ups, letting you build unique combat styles.',
            text: ''
        },
        {
            title: '• Tactical Combat & Waves – Fight hordes of ancient spirits, tomb beasts, and powerful bosses. Use positioning, environmental cover, and skill-based dodging to overcome relentless enemy assaults.',
            text: ''
        },
        {
            title: '• Loot & Unlockables – Collect ancient coins, spirit charms, and legendary weapons to strengthen your escape attempt.',
            text: ''
        },
        {
            title: '• Compact & Engaging Sessions – Fast-paced, single-player levels designed for quick, satisfying play.',
            text: ''
        },
        {
            title: '• Bonus Challenge Modes – Take on special themed stages that test your survival and puzzle-solving skills to the limit.',
            text: ''
        }
    ]
}
export default config;